/**
 * Whether City of Thirst is out yet.
 *
 * Flipped by hand and deployed on release morning, 2026-08-19 — deliberately
 * not a date check. A date would flip on the *visitor's* clock, so anyone an
 * hour east of us would see the release early. The cost of doing it this way is
 * that release day needs a deploy: left alone, the site stays quiet.
 *
 * `false` hides every trace of the single — the mouth and its bubble on Home,
 * the video on /watch, and the /music-video player. Turning it `true` brings all
 * three back and nothing else changes. Tickets 035 and 036 fill in the popup's
 * remaining store links on the same day; they are independent of this flag,
 * because with it `false` nobody can open the popup to see them.
 *
 * See tasks/039-hide-city-of-thirst-until-release.md.
 */
// Annotated `boolean` rather than left as the literal `false`: without it
// TypeScript narrows every use to the dead branch, and the released side of each
// conditional stops being typechecked until the day it ships.
export const CITY_OF_THIRST_RELEASED: boolean = true;
